import { NavInline, Navigation } from "bossfotos-design-system";

import { BossFotosNavBarLogo } from "../../design-system/BossFotosNavBarLogo";
import MenuButton from "../../v3_components/navigation/MenuButton";
import HelpButton from "../../v3_components/navigation/HelpButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { IconButton } from "@material-ui/core";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./Events.module.css";

export const NavBar = ({
  onMenuClicked,
  onHelpClicked,
  event_album_name = "",
  photographerNickName = "",
  showBackButton = false,
}: {
  onMenuClicked: () => void;
  onHelpClicked?: () => void;
  event_album_name?: string;
  photographerNickName?: string;
  showBackButton?: boolean;
}) => {
  const navigate = useNavigate();
  const { gallery_event_name } = useParams();
  const handleMenuIconClick = () => {
    onMenuClicked();
  };
  const handleHelpIconClick = () => {
    onHelpClicked && onHelpClicked();
  };

  const handleBackClicked = () => {
    if (showBackButton && gallery_event_name) {
      navigate(`/customer/events/${gallery_event_name}`)
    } else {
      navigate(-1)
    }
  };

  const heading = () => {
    if (event_album_name) {
      return <p className={`${styles.navbartitle}`}>{ event_album_name }</p>
    } else if (photographerNickName) {
      return <p className={`${styles.navbartitle}`}>{ photographerNickName }</p>
    } else {
      return <BossFotosNavBarLogo height={28} />
    }
  }

  return (
    <Navigation>
      { showBackButton ?
        <IconButton onClick={handleBackClicked} className={`${styles.iconbtn}`}>
          <ArrowBackIcon />
        </IconButton>
        :
        <MenuButton />
      }
      <NavInline>
        { heading() }
      </NavInline>
      <HelpButton />
    </Navigation>
  );
};
